/**
 * POPULATION-OVERVIEW
 * Dashboard for the population
 */
import { useAppDispatch, useAppSelector } from "@/core/root-reducer"
import { FadeIn } from "@/utils/animations.utils"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import populationStore from "../model/population.store"
import { useEffect } from "react"
import siteStore from "@/entities/site/model/site.store"
import { risksPopulationsNavItem, risksSitesNavItem } from "@/nav/nav.app"
import { useNavigate } from "react-router-dom"
import physicalRiskStore from "@/entities/physical-risk/model/physical-risk.store"
import PhysicalRiskCard from "@/entities/physical-risk/ui/PhysicalRiskCard"
import useOpenPhysicalRiskFromQuery from "@/entities/physical-risk/hooks/useOpenPhysicalRiskFromQuery"
import PageHeader from "@/components/page-header"
import { useRisksSpace } from "@/core/risks-space.context"
import PopulationRpsCard from "./PopulationRpsCard"

export default function PopulationOverview() {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const { getPath } = useRisksSpace()

  //Selectors
  const population = useAppSelector(populationStore.selectors.active)
  const risksForPopulation = useAppSelector(physicalRiskStore.selectors.listFilteredForPopulation)
  const sitesForPopulation = useAppSelector(siteStore.selectors.list).filter((x) =>
    x.populationIds.includes(population.id)
  )

  useOpenPhysicalRiskFromQuery(risksForPopulation)

  useEffect(() => {
    dispatch(siteStore.actions.select([]))
    dispatch(physicalRiskStore.actions.select([]))
    dispatch(populationStore.actions.search({ value: null, columns: ["name"] }))
  }, [dispatch, population.id])

  return (
    <FadeIn className="overview-header box-border h-full overflow-y-auto px-40 pb-80 pt-20">
      <PageHeader section="Risques" title={population.name} />

      <div className="flex flex-wrap grey-t">
        {population.size > 0 && (
          <span className="mr-20">
            {risksPopulationsNavItem.icon && (
              <FontAwesomeIcon icon={risksPopulationsNavItem.icon} className="mt-[1px] mr-2" />
            )}
            {population.size} collaborateur{population.size > 1 ? "s" : ""}
          </span>
        )}
        {sitesForPopulation.length > 0 && risksSitesNavItem.icon && (
          <FontAwesomeIcon icon={risksSitesNavItem.icon} className="mt-[2px] mr-2" />
        )}
        {sitesForPopulation.map((site, i) => (
          <div key={site.id} className="_hover" onClick={() => navigate(getPath(`/sites/${site.id}`))}>
            {site.name}
            {i < sitesForPopulation.length - 1 && ","}
            &nbsp;
          </div>
        ))}
      </div>

      <div className="grey-t mt-[16px]">
        <b>Risques psychosociaux</b>
      </div>
      <PopulationRpsCard key={population.id} population={population} />

      {risksForPopulation.length > 0 && (
        <div className="grey-t mt-40">
          <b>Risques physiques</b>
        </div>
      )}

      <div className="flex flex-wrap">
        {risksForPopulation.map((risk) => {
          return <PhysicalRiskCard key={risk.id} risk={risk} />
        })}
      </div>
    </FadeIn>
  )
}
